export const onChnageAboutSurvey = (state, payload) => {
    return {
        ...state,
        localStateData: {
            ...state.localStateData,
            aboutSurvey: payload.aboutSurvey
        }
    }
}